import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SemanticSearchState, SemanticSearchRequest } from './types'

const initialState: SemanticSearchState = {
  results: null,
  loading: false,
  error: null,
}

const { actions, reducer } = createSlice({
  name: 'semanticSearch',
  initialState,
  reducers: {
    runSemanticSearch: (state, action: PayloadAction<SemanticSearchRequest>) => {
      state.loading = true
      state.error = null
      void action
    },

    runSemanticSearchSuccess: (state, action: PayloadAction<string[]>) => {
      state.loading = false
      state.error = null
      state.results = action.payload
    },

    runSemanticSearchFailure: (state, action: PayloadAction<{ error: Error }>) => {
      state.loading = false
      state.error = action.payload.error
      state.results = null
    },

    reset: () => initialState,
  },
})

export { actions as semanticSearchActions, initialState }
export default reducer
